import lodash from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';


export const createDeepEqualitySelector = createSelectorCreator(
  defaultMemoize,
  lodash.isEqual
);
